/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_ColorInputs */



/**
* | output |
* | --- |
* | "Speaker Color..." |
*
* @param {Speaker_ColorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_color = /** @type {((inputs?: Speaker_ColorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_ColorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur de l'intervenant...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecherfarbe...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore altoparlante...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цвет динамика...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color del altavoz...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扬声器颜色...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーの色...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर का रंग...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor do alto-falante...")
	return /** @type {LocalizedString} */ ("Speaker Color...")
});